import ButtonIconH from "./ButtonIconH";

export function DeliveryNoteOptionsBox({
  step,
  onStartReading,
  onSave,
  onDelete,
  onManualCreation,
  draft,
  disabled,
  onClickCatalogues,
}) {
  return (
    <div className="delivery-note-options-container">
      <div className="opt-table-title">Opciones albarán</div>
      <div>
        <div className="delivery-note-buttons-container">
          <ButtonIconH
            text="Guardar"
            onClick={onSave}
            disabled={disabled}
          ></ButtonIconH>
          <ButtonIconH
            text="Eliminar"
            onClick={onDelete}
            disabled={disabled || !draft}
          ></ButtonIconH>
          <ButtonIconH
            text="Catálogos centralizados"
            onClick={onClickCatalogues}
          ></ButtonIconH>
        </div>
        <div className="delivery-note-buttons-container">
          {step === 0 && draft && (
            <>
              <ButtonIconH
                text="Iniciar lectura"
                disabled={disabled}
                onClick={onStartReading}
              ></ButtonIconH>
              <ButtonIconH
                text="Inserción manual"
                disabled={disabled}
                onClick={onManualCreation}
              ></ButtonIconH>
            </>
          )}
          <ButtonIconH
            text="Imprimir albarán"
            onClick={() => {}}
            disabled={disabled}
          ></ButtonIconH>
        </div>
      </div>
    </div>
  );
}
